import { ArrowDownRight, ArrowUpRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { formatYoy } from "./types";

interface YoyDeltaProps {
  delta: number | null | undefined;
  size?: "xs" | "sm" | "lg";
}

export function YoyDelta({ delta, size = "sm" }: YoyDeltaProps) {
  if (delta === null || delta === undefined || Number.isNaN(delta)) {
    const cls =
      size === "xs"
        ? "text-[10px] text-muted-foreground"
        : size === "lg"
          ? "text-base text-muted-foreground"
          : "text-muted-foreground";
    return <span className={cls}>—</span>;
  }
  const positive = delta >= 0;
  const Icon = positive ? ArrowUpRight : ArrowDownRight;
  const isXs = size === "xs";
  const isLg = size === "lg";
  return (
    <span
      className={cn(
        "inline-flex items-center gap-0.5 font-medium tabular-nums",
        isXs ? "text-[10px]" : isLg ? "text-base" : "text-xs",
        positive ? "text-emerald-600" : "text-red-600",
      )}
    >
      {!isXs && <Icon className={isLg ? "h-4 w-4" : "h-3 w-3"} />}
      {formatYoy(delta)}
    </span>
  );
}
